<template>
  <Layout>
    <template slot="title">{{ speakersTitle }}</template>

    <template slot="description">
      {{ speakersText }}
    </template>

    <div class="max-w-screen-xl mx-auto">
      <SpeakersList />
    </div>

    <SpeakersModal v-if="showSpeakerModal" />
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import Layout from '@/layouts/MainLayout'
import SpeakersList from '@/components/SpeakersList'
import SpeakersModal from '@/components/SpeakersModal'

export default {
  components: { Layout, SpeakersList, SpeakersModal },

  computed: {
    ...mapState('speakers', [
      'speakersTitle',
      'speakersText',
      'showSpeakerModal',
    ]),
  },

  mounted() {
    this.$store.dispatch('speakers/fetchSpeakersText')
    this.$store.dispatch('speakers/fetchSpeakersList')
  },
}
</script>
